import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-aplication-selector',
  templateUrl: './aplication-selector.component.html',
  styleUrls: ['./aplication-selector.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
})
export class AplicationSelectorComponent {
  @Input() applicationName!: string;
  @Output() applicationNameChange = new EventEmitter<string>();

  constructor() {}

  changeApplication(applicationName: string) {
    this.applicationNameChange.emit(applicationName);
  }
}
